<span class="sh-icon-badge">
  <svg sh-icon class="sh-icon" [name]="icon"></svg>
  @if (count !== null) {
    <span class="sh-icon-badge__badge {{size}} {{type}}">{{count}}</span>
  }
</span>
